import { api } from 'app/api';
import { ApiResponse, JobClosureReplyDto } from 'dtos';

export const createJobClosureReply = (values: JobClosureReplyDto) =>
  api
    .post<ApiResponse<JobClosureReplyDto>>('job-closure-replies', values)
    .then(res => res.data);
